// Lib
import React from 'react';
import PropTypes from 'prop-types';

const FilterTagComponent = ({ children }) => <span className="FilterTagComponent">{children}</span>;

FilterTagComponent.propTypes = {
    children: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.array]),
};

export default FilterTagComponent;
